// /**
//  * StartCareJourneyScreen — Reusable, standalone
//  * Uses Tailwind utility classes + global CSS variables (no inline styles)
//  *
//  * Props:
//  *  onNext(selectedJourney: string) — called when user clicks Continue
//  *  onBack()                        — called when user clicks Back
//  *  initialSelected?: string        — pre-selected journey key
//  */

// import { useState } from "react";
// import StepperProgress from "../Reusablesteps/Stepperprogress";
// import { useNavigate } from "react-router-dom";
// import Button, { BtnContinue } from "../Reusablecomponents/Button/Reusableutton";
// // ─── Journey options ────────────────────────────────────────────────────────
// const JOURNEY_OPTIONS = [
//   {
//     value: "pcos",
//     label: "PCOS / Irregular Period Journey",
//     emoji: "🔬",
//     desc: "For irregular cycles, hormonal symptoms, acne, weight changes, or cycle concerns",
//   },
//   {
//     value: "pregnancy",
//     label: "Pregnancy Start Journey",
//     emoji: "🤰",
//     desc: "For pregnancy confirmation, prenatal care, symptoms, scans, and routine check-ups",
//   },
//   {
//     value: "fertility",
//     label: "Fertility / Preconception Journey",
//     emoji: "🌿",
//     desc: "For trying to conceive, fertility planning, cycle tracking, and preconception support",
//   },
//   {
//     value: "postpartum",
//     label: "Postpartum Journey",
//     emoji: "👶",
//     desc: "For recovery after delivery, breastfeeding, mood, bleeding, and follow-up care",
//   },
//   {
//     value: "menopause",
//     label: "Perimenopause / Menopause Journey",
//     emoji: "🌡️",
//     desc: "For hot flashes, cycle changes, sleep, mood, and menopause wellness",
//   },
//   {
//     value: "general",
//     label: "General Women's Health",
//     emoji: "❤️",
//     desc: "For preventive check-ups, pelvic pain, infection symptoms, and overall wellness",
//   },
// ];

// // ─── Sub-components ──────────────────────────────────────────────────────────

// function JourneyCard({ emoji, label, desc, selected, onClick }) {
//   return (
//     <button
//       onClick={onClick}
//       className={[
//         "journey-card",
//         selected ? "journey-card--selected" : "",
//       ]
//         .filter(Boolean)
//         .join(" ")}
//     >
//       {/* Checkmark badge */}
//       {selected && (
//         <span className="journey-card__check" aria-hidden="true">
//           <svg width="10" height="8" viewBox="0 0 12 9" fill="none">
//             <path
//               d="M1 4.5L4.5 8L11 1"
//               stroke="white"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//           </svg>
//         </span>
//       )}

//       {/* Icon + title row */}
//       <div className="journey-card__header">
//         <span className="journey-card__icon" aria-hidden="true">
//           {emoji}
//         </span>
//         <p className="journey-card__title">{label}</p>
//       </div>

//       {/* Description */}
//       <p className="journey-card__desc">{desc}</p>

//       {/* CTA link */}
//       {/* <span className="journey-card__explore">Explore →</span> */}
//     </button>
//   );
// }

// // function TrustBar() {
// //   const items = ["🔒 Secure", "👩‍⚕️ Expert-led", "🌸 Personalised"];
// //   return (
// //     <div className="trust-bar">
// //       {items.map((item) => (
// //         <span key={item} className="trust-bar__item">
// //           {item}
// //         </span>
// //       ))}
// //     </div>
// //   );
// // }

// function BtnBack({ onClick }) {
//   return (
//     <button onClick={onClick} className="btn-back">
//       ← Back
//     </button>
//   );
// }

// // function BtnContinue({ onClick, disabled, label = "Continue →" }) {
// //   return (
// //     <button
// //       onClick={onClick}
// //       disabled={disabled}
// //       className={["btn-continue", disabled ? "btn-continue--disabled" : ""]
// //         .filter(Boolean)
// //         .join(" ")}
// //     >
// //       {label}
// //     </button>
// //   );
// // }

// function FooterNote({ children }) {
//   return <p className="footer-note">🔒 {children}</p>;
// }

// // ─── Main Screen ─────────────────────────────────────────────────────────────
//   const TRUST_ITEMS = [
//     { icon: "🔒", title: "Private & secure", desc: "Your data is encrypted end-to-end" },
//     { icon: "👩‍⚕️", title: "Clinically guided", desc: "Programs by women's health experts" },
//     { icon: "🎯", title: "Personalised for you", desc: "Matched to your life stage & goals" },
//   ];
//  export const TrustStrip = () => (
//     <div className="grid grid-cols-3 gap-4 border border-[var(--primary-color)] rounded-2xl p-4 bg-[var(--ava-bg-primary-light)] mt-2">
//       {TRUST_ITEMS.map((t, i) => (
//         <div key={i} className="flex items-start gap-3">
//           <span className="text-xl">{t.icon}</span>
//           <div>
//             <div className="text-xs font-bold text-[var(--primary-color)] mb-0.5">{t.title}</div>
//             <div className="text-xs text-gray-500 leading-relaxed">{t.desc}</div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// export default function StartCareJourneyScreen({
//   onNext,
//   onBack,
//   stepIndex, totalSteps,
//   initialSelected = null,
// }) {
//   const [selected, setSelected] = useState(initialSelected);
//   const navigate = useNavigate();



//   return (
//     <>
//       <>

//         {/* ── Header ── */}
//         <div className="scj-header">
//           <div className="scj-header__text">
//             <h1 className="scj-header__title">Start Care Journey</h1>
//             <p className="scj-header__subtitle">
//               Choose the care path that best matches your current need. We'll
//               guide you step by step.
//             </p>
//           </div>
//           <StepperProgress current={stepIndex} total={totalSteps} />
//           {/* <span className="scj-header__hero-icon" aria-hidden="true">
//             👩‍⚕️
//           </span> */}
//         </div>

//         {/* ── Journey grid ── */}
//         <div className="scj-grid-wrap">
//           <p className="scj-grid-wrap__label">Choose your journey</p>
//           <div className="scj-grid">
//             {JOURNEY_OPTIONS.map((opt) => (
//               <JourneyCard
//                 key={opt.value}
//                 emoji={opt.emoji}
//                 label={opt.label}
//                 desc={opt.desc}
//                 selected={selected === opt.value}
//                 onClick={() => setSelected(opt.value)}
//               />
//             ))}
//           </div>
//           <TrustStrip />
//           {/* <TrustBar /> */}
//         </div>
//         {/* ── Footer ── */}
//         <div className="footer-bar">
//           <div className="footer-bar__left">
//             <Button variant="outline" onClick={() => navigate(-1)}>Back</Button>
//           </div>
//           <div className="footer-bar__center">
//             <FooterNote>You can change your selected journey later.</FooterNote>
//           </div>
//           <div className="footer-bar__right">
//             <BtnContinue variant="primary" onClick={() => onNext(selected)}>Continue</BtnContinue>
//             {/* <BtnContinue
//               // disabled={!selected}
//               onClick={() => onNext(selected)}
//             /> */}
//           </div>
//         </div>
//       </>
//     </>
//   );
// }

/**
 * StartCareJourneyScreen — JSON-driven
 * Reads from screens.startCareJourney in the shared content JSON.
 *
 * Props:
 *  onNext(selectedJourney: string) — called when user clicks Continue
 *  onBack()                        — called when user clicks Back
 *  initialSelected?: string        — pre-selected journey key
 */

import { useState } from "react";
import StepperProgress from "../Reusablesteps/Stepperprogress";
import { useNavigate } from "react-router-dom";
import Button, { BtnContinue } from "../Reusablecomponents/Button/Reusableutton";
// import content from './CareJourney.json'

// ─── Sub-components ──────────────────────────────────────────────────────────

function JourneyCard({ icon, title, description, selected, onClick }) {
  return (
    <button
      onClick={onClick}
      className={["journey-card ava-card-default", selected ? "ava-card-selected" : ""]
        .filter(Boolean)
        .join(" ")}
    >
      {selected && (
        <span className="journey-card__check" aria-hidden="true">
          <svg width="10" height="8" viewBox="0 0 12 9" fill="none">
            <path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      )}
      <div className="journey-card__header">
        <span className="journey-card__icon" aria-hidden="true">{icon}</span>
        <p className="journey-card__title">{title}</p>
      </div>
      <p className="journey-card__desc">{description}</p>
    </button>
  );
}
 
export function TrustStrip({ items = [] }) {
  if (items.length === 0) return null;
  return (
    // <div className="grid grid-cols-3 gap-4 border border-[#CE93D8] rounded-2xl p-4 bg-[#F3E5F5] mt-2">
    
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 border border-[#CE93D8] rounded-2xl p-4 bg-[#F3E5F5] mt-2">
      {items.map((t, i) => (
        <div key={i} className="flex items-start gap-3">
          <span className="text-xl">{t.icon}</span>
          <div>
            <div className="text-xs font-bold text-[#38006b] mb-0.5">{t.title}</div>
            <div className="text-xs text-gray-500 leading-relaxed">{t.desc}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

function FooterNote({ children }) {
  return <p className="footer-note">🔒 {children}</p>;
}

// ─── Main Screen ─────────────────────────────────────────────────────────────

export default function StartCareJourneyScreen({
  careJourneyContent,
  onNext,
  onBack,
  stepIndex,
  totalSteps,
  initialSelected = null,
}) {
  const [selected, setSelected] = useState(initialSelected);
  const navigate = useNavigate();

  const screen = careJourneyContent?.screens?.startCareJourney;

  if (!screen) {
    console.error("startCareJourney config missing from femcare-content.json");
    return null;
  }

  const { pageTitle, pageSubtitle, sectionLabel, journeyOptions, sideCard, skipLabel, skipUrl } = screen;

  return (
    <>
      {/* ── Header ── */}
      <div className="scj-header">
        <div className="scj-header__text">

          <h1 className="scj-header__title">{pageTitle}</h1>
          <p className="scj-header__subtitle">{pageSubtitle}</p>
        </div>
        <StepperProgress current={stepIndex} total={totalSteps} />
      </div>

      {/* ── Journey grid ── */}
      <div className="scj-grid-wrap">
        <p className="scj-grid-wrap__label">{sectionLabel}</p>
        <div className="scj-grid">
          {journeyOptions.map((opt) => (
            <JourneyCard
              key={opt.value}
              icon={opt.icon}
              title={opt.title}
              description={opt.description}
              selected={selected === opt.value}
              onClick={() => setSelected(opt.value)}
            />
          ))}
        </div>
        <TrustStrip items={sideCard?.items} />
      </div>

      {/* ── Footer ── */}
      <div className="footer-bar">
        <div className="footer-bar__left">
          <Button variant="outline" onClick={() => navigate(skipUrl ?? "/")}>
            {skipLabel ?? "Skip"}
          </Button>
        </div>
        <div className="footer-bar__center">
          <FooterNote>{sideCard?.infoBubble}</FooterNote>
        </div>
        <div className="footer-bar__right">
          <BtnContinue
            variant="primary"
            // disabled={!selected}
            label={careJourneyContent.screens.welcome.ctaLabel}
            onClick={() => onNext(selected)}
          >
            {sideCard?.ctaLabel ?? "Continue"}
          </BtnContinue>
        </div>
      </div>
    </>
  );
}